import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaDropdownContent from './VaDropdownContent.vue'

export default withConfigTransport(VaDropdownContent)
